import VimeoPlayer from "../slice-components/vimeo";
import React from 'react';

export const ResourceVideo = (props) => {

    const sc = props.slice.primary;


    return (
        <section className="gutter top res-sec">
            <div className="res-section wrapper">
                <div className="video-wrapper res-video"><VimeoPlayer videoId={sc.video} /></div>
                <div className="text-center">{sc.video_caption}</div>
            </div>
        </section>
    );
}

